// Loads Microsoft Clarity only when REACT_APP_CLARITY_PROJECT_ID is set.
// That env var should only be configured on the live/production SWA environment,
// so dev and testing builds never send Clarity data.
export const initClarity = () => {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  if (!projectId) {
    return;
  }

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', projectId);
};

// Associates the current Clarity session with the logged-in customer, best-effort.
// Must never throw or block the caller: Clarity only loads when
// REACT_APP_CLARITY_PROJECT_ID is set, so window.clarity may be undefined
// in dev/test builds. Purely for analytics segmentation.
export const identifyClarityUser = (user) => {
  try {
    if (typeof window === 'undefined' || typeof window.clarity !== 'function') {
      return;
    }
    if (!user || !user.id) {
      return;
    }
    const name = user.firstname
      ? `${user.firstname} ${user.lastname || ''}`.trim()
      : undefined;
    window.clarity('identify', String(user.id), undefined, undefined, name);

    const role = Array.isArray(user.user_roles) && user.user_roles[0]
      ? user.user_roles[0].role_id
      : undefined;
    if (role !== undefined && role !== null && role !== '') {
      window.clarity('set', 'role', String(role));
    }
  } catch (e) {
    // Swallow - Clarity identification is best-effort only.
  }
};
